export default __webpack_public_path__ + "static/media/inside-01-b.c254c6f8.png";